import { normalizeGenderSpecific } from "./normalizeGenderSpecific";

export const isFieldVisibleForGender = (field, selectedGender) => {
    const normalizedFieldGender = normalizeGenderSpecific(field.genderSpecific);
    if (!normalizedFieldGender) {
        return true;
    }

    if (!selectedGender || selectedGender === "NonBinary") {
        return true;
    }

    const normalizedSelectedGender = normalizeGenderSpecific(selectedGender);
    if (!normalizedSelectedGender) {
        return true;
    }

    return normalizedFieldGender === normalizedSelectedGender;
};
